import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable react/jsx-pascal-case */
import { Themed } from 'theme-ui';
import { useEntity } from '@uswitch/ev-utils/lib/context/selectors';
import sw from '@uswitch/ev-utils/lib/switch';
import { assignContentTypeId, contentTypeId, fileType } from '@uswitch/ev-utils/lib/contentful';
import Url from './url';
import Module from './module';
import { Modular, RichPage, RichTextBlock } from './page';
import { jsx as _jsx } from "theme-ui/jsx-runtime";

var Debug = function Debug(props) {
  return _jsx("pre", {
    children: JSON.stringify(props, null, 2)
  });
}; // eslint-disable-line


export var EVEntry = function EVEntry(props) {
  var rawEntity = useEntity(props);

  if (rawEntity.err) {
    console.log({
      err: rawEntity.err,
      props: props
    });
  }

  var entity = sw({
    'image/svg+xml': assignContentTypeId('imageModule'),
    'image/jpeg': assignContentTypeId('imageModule'),
    default: function _default(i) {
      return i;
    }
  })(fileType(rawEntity), rawEntity);
  return sw({
    // URL Models
    url: Url,
    // Page Models
    modularPage: Modular,
    // Rich models
    richPage: RichPage,
    richTextBlock: RichTextBlock,
    // Default to modules
    default: Module,
    // dont know what to do yet
    '': Debug,
    colour: Debug,
    layout: Debug,
    palette: Debug
  })(contentTypeId(entity), _objectSpread(_objectSpread({}, props), entity));
};
export var RootEVEntry = function RootEVEntry(props) {
  return _jsx(Themed.root, {
    children: _jsx(EVEntry, _objectSpread({}, props))
  });
};